(function () {
  if (window.__nkd) return;
  window.__nkd = 1;
  var root = document.getElementById('nkd');
  if (!root) return;
  var SEC = root.getAttribute('data-section');
  var busy = false;
  var R = window.routes || {};
  var onCart = function () { return /\/cart\/?$/.test(location.pathname); };
  var base = (R.cart_url || '/cart').replace(/cart\/?$/, '');

  function open() {
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('nkd-lock');
    var x = root.querySelector('.nkd__x');
    if (x) x.focus();
  }
  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('nkd-lock');
  }
  function refresh(openAfter) {
    return fetch(base + '?sections=' + SEC + ',cart-icon-bubble', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j[SEC]) {
          var d = new DOMParser().parseFromString(j[SEC], 'text/html');
          var n = d.getElementById('nkd-inner');
          var cur = document.getElementById('nkd-inner');
          if (n && cur) cur.innerHTML = n.innerHTML;
        }
        if (j['cart-icon-bubble']) {
          var b = document.getElementById('cart-icon-bubble');
          var s = new DOMParser().parseFromString(j['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (b && s) b.innerHTML = s.innerHTML;
        }
        if (openAfter) open();
      })
      .catch(function () { if (openAfter) open(); });
  }
  function post(url, body) {
    busy = true;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function () { busy = false; return refresh(false); })
      .catch(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    if (t.closest('[data-nkd-close]')) { close(); return; }
    var q = t.closest('[data-nkd-qty]');
    if (q) {
      post((R.cart_change_url || '/cart/change') + '.js', { line: parseInt(q.getAttribute('data-line'), 10), quantity: parseInt(q.getAttribute('data-q'), 10) });
      return;
    }
    var a = t.closest('[data-nkd-add]');
    if (a) {
      a.disabled = true;
      post((R.cart_add_url || '/cart/add') + '.js', { id: parseInt(a.getAttribute('data-nkd-add'), 10), quantity: 1 });
      return;
    }
    var link = t.closest('a[href]');
    if (link && !onCart() && !link.closest('#nkd')) {
      var p = link.getAttribute('href').split('?')[0].replace(/\/$/, '');
      if (/\/cart$/.test(p)) {
        e.preventDefault();
        refresh(true);
      }
    }
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  var of = window.fetch;
  window.fetch = function () {
    var u = arguments[0];
    var url = typeof u === 'string' ? u : (u && u.url) || '';
    var p = of.apply(this, arguments);
    if (!busy && !onCart() && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
      p.then(function (r) { if (r && r.ok) setTimeout(function () { refresh(true); }, 60); }).catch(function () {});
    }
    return p;
  };
  window.nkdOpen = function () { refresh(true); };
})();